<template>
  <div>
    <h2>
      <span class="step-name"> Animal Numbers - Dairy Support </span>
      <comments field-name="heading_animal_numbers_dairy_support"></comments>
    </h2>

    <h3>Animal numbers are numbers wintered or expected to be wintered for the consult year</h3>

    <div
      class="step-section clearfix"
      v-for="gf_animal in enabledAnimals('dairy_support', false)"
      :key="'dairy_support_' + gf_animal.id"
    >
      <h3>{{ gf_animal.name }}</h3>

      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <text-area label="Animal Notes from Ezyvet" :field-name="`animal_${gf_animal.id}-notes`" disabled> </text-area>
        </div>
      </div>

      <div class="col-md-6">
        <h3>Previous Consult</h3>

        <div class="form-group input-box">
          <label>Rising 1 Year</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-r1`]"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Rising 2 Years</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-r2`]"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Winter MA Cows</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-ma_cows_winter`]"
            disabled
          />
        </div>

        <div class="form-group input-box">
          <label>Carry Overs</label>
          <input
            type="text"
            class="form-control"
            :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-carry_overs`]"
            disabled
          />
        </div>
      </div>

      <div class="col-md-6">
        <h3>This Year</h3>

        <number-input label="Rising 1 Year" field-name="r1" :farm-id="gf_animal.id" fieldPrefix="animal"></number-input>

        <number-input label="Rising 2 Year" field-name="r2" :farm-id="gf_animal.id" fieldPrefix="animal"></number-input>

        <number-input
          label="Winter MA Cows"
          field-name="ma_cows_winter"
          :farm-id="gf_animal.id"
          fieldPrefix="animal"
        ></number-input>

        <number-input
          label="Carry Overs"
          field-name="carry_overs"
          :farm-id="gf_animal.id"
          fieldPrefix="animal"
        ></number-input>
      </div>
    </div>

    <div
      class="step-section clearfix"
      v-for="gf_animal in newAnimals('dairy_support')"
      :key="'dairy_support_' + gf_animal.frontend_id"
    >
      <div class="row">
        <h3>{{ gf_animal.name }} - (Newly created)</h3>
      </div>
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <text-area
            label="Animal Notes from Ezyvet"
            :farm-id="Number(gf_animal.frontend_id)"
            field-prefix="new_animal"
            field-name="notes"
          >
          </text-area>
        </div>

        <div class="col-md-6 col-md-offset-3">
          <h3>This Year</h3>

          <number-input label="Rising 1 Year" field-name="r1" fieldPrefix="new_animal" :farm-id="gf_animal.frontend_id">
          </number-input>

          <number-input
            label="Rising 2 Years"
            field-name="r2"
            fieldPrefix="new_animal"
            :farm-id="gf_animal.frontend_id"
          >
          </number-input>

          <number-input
            label="Winter MA Cows"
            field-name="ma_cows_winter"
            fieldPrefix="new_animal"
            :farm-id="gf_animal.frontend_id"
          >
          </number-input>

          <number-input
            label="Carry Overs"
            field-name="carry_overs"
            fieldPrefix="new_animal"
            :farm-id="gf_animal.frontend_id"
          >
          </number-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

import { mapGetters } from 'vuex'

export default {
  name: 'AnimalNumbersDairySupport',
  mixins: [baseComponent],
  mounted() {
    for (const newAnimal of this.newAnimals('dairy_support')) {
      let fieldName = this.prefixedField('notes', newAnimal.frontend_id, 'new_animal')
      if (this.getFieldValue(fieldName) == undefined) {
        this.setFieldValue({
          fieldName: fieldName,
          modelName: this.$options.name,
          value: newAnimal.notes,
        })
      }
    }
  },
  computed: {
    ...mapGetters('currentConsult', ['enabledAnimals', 'newAnimals']),
  },
}
</script>
